export default {
    cambodia: 'Cambodia',
    thailand: 'Thailand',
    in_region: 'in region {regionName}',
};
